export enum MessageResultState {
  ERROR = 0,
  SUCCESS = 1,
  WARNING = 2,
}

export interface ServiceResult<T = any> {
  result: T;
  isSuccess: boolean;
  message: string;
  state: MessageResultState;
}

export interface AxiosResponse<T> {
  data: T;
  status: number;
  statusText: string;
  headers: any;
  request?: any;
}
